import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook, FaApple } from "react-icons/fa";
import { IoMdEye } from "react-icons/io";
import { IoMdEyeOff } from "react-icons/io";


const SignupPage = ({ onSignupSuccess, onLoginClick }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "", confirmPassword: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validateForm = () => {
    let valid = true;
    let emailError = "";
    let passwordError = "";
    let confirmPasswordError = "";

    if (!email) {
      emailError = "Email is required.";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailError = "Please enter a valid email address.";
      valid = false;
    }

    if (!password) {
      passwordError = "Password is required.";
      valid = false;
    } else if (password.length < 6) {
      passwordError = "Password must be at least 6 characters long.";
      valid = false;
    }

    if (!confirmPassword) {
      confirmPasswordError = "Please confirm your password.";
      valid = false;
    } else if (password !== confirmPassword) {
      confirmPasswordError = "Passwords do not match.";
      valid = false;
    }

    setErrors({ email: emailError, password: passwordError, confirmPassword: confirmPasswordError });
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const userInfo = {
        email,
        password
      };
      onSignupSuccess(userInfo);
    }
  };

  return (
    <div className="h-full w-full max-w-sm mx-auto">
      <div className="bg-white rounded-3xl h-full p-8">
        <h1 className="font-young-serif text-[30px] font-normal leading-8 text-center mb-6">
          Create an
          <p /> account to save
          <p /> your progress
        </h1>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              className="w-full border border-gray-300 text-[16px] text-[#929292] font-space-grotesk font-normal rounded-full px-5 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
          </div>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Create password"
              className="w-full border border-gray-300 text-[16px] text-[#929292] font-space-grotesk font-normal rounded-full px-5 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500"
            >
              {showPassword ? <IoMdEyeOff /> : <IoMdEye />}
            </button>
            {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
          </div>
          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm password"
              className="w-full border border-gray-300 text-[16px] text-[#929292] font-space-grotesk font-normal rounded-full px-5 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500"
            >
              {showConfirmPassword ? <IoMdEyeOff /> : <IoMdEye />}
            </button>
            {errors.confirmPassword && (
              <p className="text-red-500 text-sm mt-1">{errors.confirmPassword}</p>
            )}
          </div>
          <button
            type="submit"
            className="bg-[#B08CFF] font-space-grotesk w-full text-[#1E0A1E] text-[18px] font-bold py-2 rounded-full hover:bg-purple-600 transition duration-200"
          >
            Sign up
          </button>
        </form>

        <div className="flex items-center my-6">
          <span className="flex-grow border-t border-gray-300"></span>
          <span className="mx-4 text-[14px] text-[#929292] font-space-grotesk">OR</span>
          <span className="flex-grow border-t border-gray-300"></span>
        </div>
        <div className="space-y-4">
          <button className="font-space-grotesk w-full flex items-center justify-center bg-[#EEEEEE] border text-[#1E0A1E] py-2 rounded-full text-16px font-medium">
            <FaApple className="h-5 w-5 mr-2" />
            Continue with Apple
          </button>
          <button className="font-space-grotesk w-full flex items-center justify-center bg-[#EEEEEE] border text-[#1E0A1E] py-2 rounded-full text-16px font-medium">
            <FcGoogle className="h-5 w-5 mr-2" />
            Continue with Google
          </button>
          <button className="font-space-grotesk w-full flex items-center justify-center bg-[#EEEEEE] border text-[#1E0A1E] py-2 rounded-full text-16px font-medium">
            <FaFacebook className="h-5 w-5 mr-2 text-[#1877F2]" />
            Continue with Facebook
          </button>
        </div>
        <p className="font-space-grotesk text-[12px] font-normal text-center mt-6 text-[#1E0A1E]">
          By tapping Continue or logging into an existing Famjam, you agree to our{" "}
          <a href="#" className="underline">
            Terms
          </a>{" "}
          and acknowledge our{" "}
          <a href="#" className="underline">
            Privacy Policy
          </a>
          .
        </p>
        <div className="flex items-center mt-4">
          <input
            type="checkbox"
            id="offers"
            className="appearance-none h-4 w-4 border border-gray-300 rounded-full checked:bg-purple-500 checked:border-transparent focus:outline-none"
          />
          <label htmlFor="offers" className="font-space-grotesk ml-2 text-[12px] font-normal text-[#1E0A1E">
            I want to hear more about offers and promos
          </label>
        </div>
        <p className="font-space-grotesk text-center text-[16px] font-medium text-[#1E0A1E] mt-4">
          Have an account?{" "}
          <button
            onClick={onLoginClick}
            className="text-[#B08CFF]"
          >
            Log in
          </button>
        </p>
      </div>
    </div>
  );
};

export default SignupPage;